import congressDemographics from '../../DemographicData/congress-demographics.json'
import stUpperDemographics from '../../DemographicData/statelegupper-demographics.json'
import stLowerDemographics from '../../DemographicData/stateleglower-demographics.json'
import tractDemographics from '../../DemographicData/tracts-demographics.json'
import tractVAPDemographics from '../../DemographicData/tracts-voting-demographics.json'
export default class ChoroplethLayerConfig {
    constructor(_config) {
        this.zoomThreshold = 0; //Depricated for mapbox. When using mapbox wide/close tiles, set to the zoom level where they switch
        this.overlap = 0;
        this.layers = [
            {
                'id': _config.enums.LEG_BODY.CONGRESS,
                'type': 'fill',
                //'source': `${_config.enums.LEG_BODY.CONGRESS}-choro-source`,
                'source': `congress-choro-source`,
                'source-layer': `congress_demographics`,
                'minzoom': this.zoomThreshold-this.overlap,
                'layout': {
                    // make layer visible by default
                    'visibility': 'visible',
                },
                'paint': {
                    //'fill-color': |* Set programatically based on scale values*|,
                    'fill-opacity': 0.8, //.5
                    'fill-antialias': false, //disables outline if false
                    'fill-outline-color': [ "step", ["zoom"],'rgba(0,0,0,0)', 5,'#fff']
                    
                },
                'params': {
                    beforeId: 'choropleth-placeholder', 
                    type: 'jurisdiction',
                    data: congressDemographics,
                    dataStyle: null
                }
            },
            {
                'id': _config.enums.LEG_BODY.ST_UPPER,
                'type': 'fill',
                //'source': `${_config.enums.LEG_BODY.ST_UPPER}-choro-source`,
                'source': `statelegupper-choro-source`,
                'source-layer': `statelegupper_demographics`,
                'minzoom': this.zoomThreshold-this.overlap,
                'layout': {
                    'visibility': 'none',
                },
                'paint': {
                    //'fill-color': matchExpression,
                    'fill-opacity': 0.8, //.5
                    'fill-antialias': false, //disables outline if false
                    'fill-outline-color': [ "step", ["zoom"],'rgba(0,0,0,0)', 5,'#fff']
                },
                'params': {
                    beforeId: 'choropleth-placeholder', 
                    type: 'jurisdiction',
                    data: stUpperDemographics,
                    dataStyle: null
                }

            },
            {
                'id': _config.enums.LEG_BODY.ST_LOWER,
                type: "fill",
                //source: `${_config.enums.LEG_BODY.ST_LOWER}-choro-source`,
                'source': `stateleglower-choro-source`,
                "source-layer": "stateleglower_demographics",
                'minzoom': this.zoomThreshold-this.overlap,
                'layout': {
                    'visibility': 'none',
                },
                paint: {
                    'fill-opacity': 0.8, //.5
                    'fill-antialias': false, //disables outline if false
                    'fill-outline-color': [ "step", ["zoom"],'rgba(0,0,0,0)', 5,'#fff']
                },
                'params': {
                    beforeId: 'choropleth-placeholder', 
                    type: 'jurisdiction',
                    data: stLowerDemographics,
                    dataStyle: null
                }
            },
            {
                'id': 'tract-cvap',
                type: "fill",
                source: `tract-cvap-choro-source`,
                "source-layer": "tract19_vb-b680ns",
                //"source-layer": "tiger20tractsUScb500k-2ontwt",
                'minzoom': this.zoomThreshold-this.overlap,
                'layout': {
                    'visibility': 'none',
                },
                paint: {
                    'fill-opacity': 0.8, //.5
                    'fill-antialias': [ "step", ["zoom"],true, 8,false]
                    //'fill-outline-color':'rgba(0,0,0,0)'
                },
                'params': {
                    beforeId: 'choropleth-placeholder', 
                    type: 'tract',
                    data: tractDemographics,
                    dataStyle: null
                }
            },
            {
                'id': 'tract-vap',
                type: "fill",
                source: `tract-vap-choro-source`,
                //"source-layer": "tract19_vb-b680ns",
                "source-layer": "tiger20tractsUScb500k-2ontwt",
                'minzoom': this.zoomThreshold-this.overlap,
                'layout': {
                    'visibility': 'none',
                },
                paint: {
                    'fill-opacity': 0.8, //.5
                    'fill-antialias': [ "step", ["zoom"],true, 8,false]
                    //'fill-outline-color':'rgba(0,0,0,0)'
                },
                'params': {
                    beforeId: 'choropleth-placeholder', 
                    type: 'tract-vap',
                    data: tractVAPDemographics,
                    dataStyle: null
                }
            },
            {
                'id': 'voting-precincts',
                type: "fill",
                source: `voting-precincts`,
                "source-layer": "nytimes2020precinctresults",
                'minzoom': this.zoomThreshold-this.overlap,
                'layout': {
                    'visibility': 'none',
                },
                paint: {
                    'fill-opacity': .8, //.5
                    'fill-antialias': [ "step", ["zoom"],true, 10,false],
                    //'fill-color': '#f00'
                    //'fill-outline-color':'rgba(0,0,0,0)'
                    'fill-color': [
                        'step', // arg 1
                        ['get', 'bidenpct'], // arg 2
                        '#888', // arg 3
                        // 0, '#D9091B', // rest of the expression is arg 4
                        // .10, '#CD0D22',
                        // .20, '#AD1637',
                        // .30, '#812453',
                        // .40, '#762759',
                        // .50, '#4F3372',
                        // .60, '#3D387D',
                        // .70, '#293F8B',
                        // .80, '#164496',
                        // .90, '#174597',
                        // 1.00, '#1644CC'
                        0, '#b2182b',
                        .20, '#ef8a62',
                        .40, '#fddbc7',
                        .50, '#d1e5f0',
                        .60, '#67a9cf',
                        .80, '#2166ac'
                        // ,
                        // 1.00, '#1644CC'
                    ]
                       // ['#b2182b','#','#','#','#','#']
                    //    {
                    //     'property': 'bidenpct',
                    //     'stops': [
                    //       [0, 'darkred'],
                    //       [.5, 'lightgrey'],
                    //       [1, 'darkblue']
                    //     ]
                    //   },
                },
                'params': {
                    beforeId: 'choropleth-placeholder', 
                    type: 'voting-precinct',
                    //data: tractDemographics,
                    //dataStyle: null
                }
            },
        ]

    }
}